<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%;">
			<el-dialog :title="titmc" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="12">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
					</el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="水毁时间" prop="sdate">
          		<el-date-picker :disabled="states=='ck'" v-model.trim="ruleForm.sdate" type="date" class="from-el-input-item" value-format="yyyy-MM-dd" placeholder="水毁时间"></el-date-picker>
          	</el-form-item>
          </el-col>
				</el-row>
        <el-row>
          <el-col :span="12">
          	<el-form-item type="type" label="修复计划" prop="xfjh">
          		<el-input type="type" class="from-el-input" placeholder="修复计划名称" v-model.trim="ruleForm.xfjh" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
          <el-col :span="12">
          	<el-form-item type="type" label="截止期限" prop="ddate">
          		<el-date-picker :disabled="states=='ck'" v-model.trim="ruleForm.ddate" type="date" class="from-el-input-item" value-format="yyyy-MM-dd" placeholder="修复截止期限"></el-date-picker>
          	</el-form-item>
          </el-col>
        </el-row>
				<el-row>
				</el-row>
				<el-row>
          <el-col :span="12">
          	<el-form-item type="type" label="技术负责人" prop="fzr">
              <el-input type="type" class="from-el-input" placeholder="防汛技术负责人" v-model.trim="ruleForm.fzr" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
					<el-col :span="12">
						<el-form-item type="type" label="联系方式" prop="lxfs">
							<el-input type="type" class="from-el-input" placeholder="防汛技术责任人联系方式" v-model.trim="ruleForm.lxfs" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item type="type" label="修复计划说明" prop="jysm">
							<el-input type="textarea" :rows="3" class="from-el-input-text" placeholder="修复计划说明" v-model.trim="ruleForm.jysm" :disabled="states=='ck'"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
        <el-row>
        	<el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData1.length!=0">
        		<div class="titna">
        			<span class="addSpan">修复前图片</span>
        		</div>
        		<div class="tp" v-if="states=='xz'||states=='bj'">
        			<el-upload action :auto-upload="false" list-type="picture-card" :limit="1" :on-preview="imghandl1" :on-change="imgchanges1" :on-remove="imghandleRemove1">
        			</el-upload>
              <div class='fujian fujians' v-if="ImgfileListData1.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in ImgfileListData1" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'xfq')"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
        		</div>
        		<div class="tp tps" v-if="states=='ck' && ImgfileListData1.length!=0">
        			<ul class="qrtpul">
        				<li class v-for="(item,i) in ImgfileListData1" :key="i">
        					<img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
        				</li>
        			</ul>
        		</div>
        	</el-col>
        </el-row>
        <el-row>
        	<el-col :span="24" class="col-class" v-if="states=='xz'||states=='bj' || ImgfileListData2.length!=0">
        		<div class="titna">
        			<span class="addSpan">修复后图片</span>
        		</div>
        		<div class="tp" v-if="states=='xz'||states=='bj'">
        			<el-upload action :auto-upload="false" list-type="picture-card" :on-preview="imghandl2" :on-change="imgchanges2" :on-remove="imghandleRemove2">
        			</el-upload>
              <div class='fujian fujians' v-if="ImgfileListData2.length!=0">
                <ul class="fjhxlist">
                  <li v-for="(item,i) in ImgfileListData2" :key="i">
                    <div class="names" style="text-align: left;">{{item.sourceName}}</div>
                    <div class="names cz">
                      <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                      <el-button type="success" icon="el-icon-delete" v-if="states!='ck'" circle @click="deletesfile(i,item,'xfh')"
                        class="btnmargin"></el-button>
                    </div>
                  </li>
                </ul>
              </div>
        		</div>
        		<div class="tp tps" v-if="states=='ck' && ImgfileListData2.length!=0">
        			<ul class="qrtpul">
        				<li class v-for="(item,i) in ImgfileListData2" :key="i">
        					<img :src="item.url" alt style="width:20%; cursor: pointer; float: left;" @click="imgzoom(item.url)" />
        				</li>
        			</ul>
        		</div>
        	</el-col>
        </el-row>
        <el-row style="margin-top:10px">
        	<el-col :span="8">
        		<el-form-item type="type" label="修复状态" prop="xfzt">
              <el-select :disabled = "states=='ck'" v-model.trim="ruleForm.xfzt" class="from-el-input" placeholder="落实情况">
              	<el-option v-for="(item,i) in xflist" :key="i" :label="item.name" :value="item.code">
              	</el-option>
              </el-select>
        		</el-form-item>
        	</el-col>
        	<el-col :span="8">
        		<el-form-item type="type" label="责任单位" prop="zrdw">
              <el-input type="type" class="from-el-input" placeholder="责任单位" v-model.trim="ruleForm.zrdw" :disabled="states=='ck'"></el-input>
        		</el-form-item>
        	</el-col>
          <el-col :span="8">
          	<el-form-item type="type" label="责任人" prop="zrdwzrr">
              <el-input type="type" class="from-el-input" placeholder="责任单位责任人" v-model.trim="ruleForm.zrdwzrr" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
          	<el-form-item type="type" label="填报单位" prop="tbdw">
              <el-input type="type" class="from-el-input" placeholder="填报单位" v-model.trim="ruleForm.tbdw" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
          <el-col :span="8">
          	<el-form-item type="type" label="填报人" prop="tbr">
              <el-input type="type" class="from-el-input" placeholder="填报人" v-model.trim="ruleForm.tbr" :disabled="states=='ck'"></el-input>
          	</el-form-item>
          </el-col>
        	<el-col :span="8">
        		<el-form-item type="type" label="填报日期" prop="fdate">
        			<el-date-picker v-model.trim="ruleForm.fdate" type="date" class="from-el-input-item" value-format="yyyy-MM-dd" placeholder="编制日期" :disabled="states=='ck'"></el-date-picker>
        		</el-form-item>
        	</el-col>
        </el-row>
				<span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button v-if="states !== 'ck'" @click="cancel()" type="warning">取 消</el-button>
            <el-button v-if="states == 'xz'" type="success" @click="xzdeteRmine('ruleForm','xz')">保 存</el-button>
            <el-button v-if="states == 'bj'" type="success" @click="xzdeteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
			</el-dialog>
		</el-form>

    <!-- 图片预览 -->
    <el-dialog :visible.sync="imgdialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
	</div>
</template>
<script>
  import { ydbjbxxQuery, shgcxfSave, shgcxfUpdate, dictioninfo, deleteFile } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  import axios from 'axios'
	let date = new Date()
	const currentFdate = date.getFullYear() + '-' + (date.getMonth()+1) + '-'+ date.getDate() + ' ' + date.getHours()+':'+date.getMinutes()+':'+date.getSeconds();
	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
        urlsss: '/userApi/minio/updateFileMulti/',
        downloadUrl: "/userApi/minio/downloadFile/",
				dialogVisible: true, // 弹出框显示
				titmc: '新建水毁工程修复',
        xflist: [],
				ruleForm: {
					ydbmc: '', // 淤地坝名称
          ydbCode: '',
          sdate: '',
          ddate: '',
					fzr: '', // 防汛技术负责人
          xfjh: '', // 修复计划
          lxfs: '',
          xfzt: '',
          zrdw: '',
          zrdwzrr: '',
          tbdw: '',
          tbr: '',
					jysm: '',
					fdate: String(currentFdate)
				},
				rules: {
					ydbmc: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          sdate: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          ddate: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					fzr: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
          xfjh: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          lxfs: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          xfzt: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' }
          ],
          zrdw: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          zrdwzrr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          tbdw: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
          tbr: [
          	{ required: true, message: '请输入必填项', trigger: 'blur' },
          	{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
          ],
					fdate: [
						{ required: true, message: '请输入必填项', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					jysm: [
						{ required: false, message: '请输入必填项', trigger: 'blur' },
						{
							min: 1,
							max: 200,
							message: '长度在 1 到 200 个字符',
							trigger: 'blur'
						}
					],
				},

				states: '',
				fileList1: [], // 修复前图片提交
        ImgfileListData1: [], // 修复前图片回显
        fileUrl1: '',
        fileList2: [], // 修复后图片提交
        ImgfileListData2: [], // 修复后图片回显
        fileUrl2: '',
        currentData: '',
        row: null,
        dialogImageUrl: '',
        imgdialogVisible: false
			}
		},
		cerate() {
			// 初始化数据
		},
		methods: {
      //获取防汛管理制度状态数字字典
      getglzdztinfo() {
        let params = {
          type: 'shgcxf',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.xflist = res.data;
        })
      },
      list(params) {
        let _this = this;
      	ydbjbxxQuery(params).then((res) => {
      		if (res.data.length !== 1) {
      		  _this.$notify({
      		    title: "提示",
      		    message: "请选择淤地坝",
      		    type: "warning"
      		  });
      		} else {
      		  _this.ruleForm.ydbCode = res.data[0].ydbCode;
      		  _this.ruleForm.ydbmc = res.data[0].ydbName;
      		}
      	})
      },
      treeClose(){
      	// let params = {};
      	// this.list(params);
      },
      objdata(data) {
      	let params = {
      		ydbCode:data.ydbCode
      	};
      	this.list(params);
      },
			handleClose(done) {
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			cancel() {
				// 取消
				this.dialogVisible = false
				this.$emit('getcancel', { dialogVisible: this.dialogVisible })
			},
			xzdeteRmine(formName, states) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }; // 添加请求头
            //修复前照片Url
            if (this.fileList1.length != 0) {
              let formData1 = new FormData();
              this.fileList1.forEach((el, index) => {
                formData1.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData1, config).then(res => {
                if(res.data.code === 200) {
                  this.fileUrl1 = res.data.data;
                }
              }).catch(err => {});
            }

            //修复后照片Url
            if (this.fileList2.length != 0) {
              let formData2 = new FormData();
              this.fileList2.forEach((el, index) => {
                formData2.append('file', el); // 'file' 可变 相当于 input 表单的name 属性
              });
              axios.post(this.urlsss, formData2, config).then(res => {
                if(res.data.code === 200) {
                  this.fileUrl2 = res.data.data;
                }
              }).catch(err => {});
            }

            let _this = this;
            setTimeout(function() {
              if (states == 'xz') {
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbShsj: _this.ruleForm.sdate, //水毁时间
                  ydbXfjzSj: _this.ruleForm.ddate, //修复截止时间
                  ydbXfjhMc: _this.ruleForm.xfjh, //修复计划名称
                  ydbXfjhSm: _this.ruleForm.jysm, //修复计划说明
                  ydbXfqZp: _this.fileUrl1, //修复前照片
                  ydbXfhZp: _this.fileUrl2, //修复后照片
                  status: _this.ruleForm.xfzt, //修复状态
                  ydbZrr: _this.ruleForm.zrdwzrr, //责任人
                  ydbZrdw: _this.ruleForm.zrdw, //责任单位
                  ydbTbr: _this.ruleForm.tbr, //填报人
                  ydbTbdw: _this.ruleForm.tbdw, //填报单位
                  ydbTbsj: _this.ruleForm.fdate, //填报日期
                };
                shgcxfSave(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("adddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              } else {
                let zhuangtai;
                if (_this.ruleForm.xfzt === '已修复') {
                  zhuangtai = 0;
                } else {
                  zhuangtai = 1;
                }
                let params = {
                  ydbName: _this.ruleForm.ydbmc, //淤地坝名称
                  ydbCode: _this.ruleForm.ydbCode, //淤地坝编号
                  ydbShsj: _this.ruleForm.sdate, //水毁时间
                  ydbXfjzSj: _this.ruleForm.ddate, //修复截止时间
                  ydbXfjhMc: _this.ruleForm.xfjh, //修复计划名称
                  ydbXfjhSm: _this.ruleForm.jysm, //修复计划说明
                  ydbXfqZp: _this.fileUrl1, //修复前照片
                  ydbXfhZp: _this.fileUrl2, //修复后照片
                  status: zhuangtai, //修复状态
                  ydbZrr: _this.ruleForm.zrdwzrr, //责任人
                  ydbZrdw: _this.ruleForm.zrdw, //责任单位
                  ydbTbr: _this.ruleForm.tbr, //填报人
                  ydbTbdw: _this.ruleForm.tbdw, //填报单位
                  ydbTbsj: _this.ruleForm.fdate, //填报日期
                  id: _this.row.id
                };
                if (params.ydbXfqZp === '') {
                  params.ydbXfqZp = null;
                }
                if (params.ydbXfhZp === '') {
                  params.ydbXfhZp = null;
                }
                shgcxfUpdate(params).then((res) => {
                  if (res.code === 200) {
                    _this.$notify({
                      title: "提示",
                      message: "提交成功",
                      type: "success"
                    });
                    _this.dialogVisible = false;
                    _this.$emit("bjadddata", {
                      dialogVisible: _this.dialogVisible
                    });
                  } else {
                    _this.$notify({
                      title: "提示",
                      message: res.message,
                      type: "warning"
                    });
                  }
                })
              }
            }, 500)
          }
        });
			},

      DownloadFile(index, row) {
      	// 下载文件
        window.open(this.downloadUrl + row.fileName);
      },
      deletesfile(index, row, type) {
      	// 删除文件
        let params = {id:row.id, fileName:row.fileName};
        deleteFile(params).then((res) => {
        	if(res.code == 200) {
        		this.$notify({
        			title: '',
        			message: res.message,
        			type: 'success'
        		});
            if(type === 'xfq') this.ImgfileListData1.splice(index, 1)
            if(type === 'xfh') this.ImgfileListData2.splice(index, 1)
        	}
        })
      },

      imgzoom(url) {
        window.open(url);
      },

      imghandl1(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },

      imghandleRemove1(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.fileList1.length; i++) {
          if (file.name == this.fileList1[i].name) {
            this.fileList1.splice(this.fileList1[i], 1);
          }
        }
      },

      imgchanges1(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.fileList1.push(file.raw)
      	}
      },

      imghandl2(file) {
        this.dialogImageUrl = file.url;
        this.imgdialogVisible = true;
      },

      imghandleRemove2(file, fileList) {
      	// 删除文件
        for (let i = 0; i < this.fileList2.length; i++) {
          if (file.name == this.fileList2[i].name) {
            this.fileList2.splice(this.fileList2[i], 1);
          }
        }
      },

      imgchanges2(file, fileList) {
      	let num = 1024.0
      	if(Number((file.size / Math.pow(num, 2)).toFixed(2)) > 10) {
      		fileList.splice(fileList.length - 1, 1)
      		this.$message.error('选择文件大于10M，请重新选择！')
      	} else {
      		this.fileList2.push(file.raw)
      	}
      },
		},
		components: {
      addressTree
		},
		mounted() {
      this.getglzdztinfo();

      this.states = this.mystate[0];
      if (this.states == 'bj' || this.states == 'ck') {
        this.row = this.mystate[1];
        this.currentData = this.mystate[1].ydbName; //淤地坝名称

        this.ruleForm.ydbmc = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.sdate = this.mystate[1].ydbShsj; //水毁时间
        this.ruleForm.ddate = this.mystate[1].ydbXfjzSj; //修复截止时间
        this.ruleForm.xfjh = this.mystate[1].ydbXfjhMc; //修复计划名称
        this.ruleForm.jysm = this.mystate[1].ydbXfjhSm; //修复计划说明
        // this.ruleForm.xfzt = this.mystate[1].status; //修复状态
        this.ruleForm.zrdwzrr = this.mystate[1].ydbZrr; //责任人
        this.ruleForm.zrdw = this.mystate[1].ydbZrdw; //责任单位
        this.ruleForm.tbr = this.mystate[1].ydbTbr; //填报人
        this.ruleForm.tbdw = this.mystate[1].ydbTbdw; //填报单位
        this.ruleForm.fdate = this.mystate[1].ydbTbsj; //填报日期

        this.ImgfileListData1 = this.mystate[1].ydbXfqZp; //修复前照片
        for (let i=0; i<this.ImgfileListData1.length; i++) {
          this.ImgfileListData1[i].url = this.downloadUrl + this.ImgfileListData1[i].fileName;
        }

        this.ImgfileListData2 = this.mystate[1].ydbXfhZp; //修复后照片
        for (let i=0; i<this.ImgfileListData2.length; i++) {
          this.ImgfileListData2[i].url = this.downloadUrl + this.ImgfileListData2[i].fileName;
        }

        if (this.mystate[1].status === 0) {
          this.ruleForm.xfzt = '已修复'; //状态
        } else {
          this.ruleForm.xfzt = '未修复'; //状态
        }
      }
    }
	}
</script>

<style scoped>
  >>>.el-dialog__body {
  	height: 520px;
  	overflow: auto;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }

  .tp {
		width: calc(100% - 122px);
		float: left;
		border: 1px solid #ccc;
		border-radius: 4px;
		padding: 10px;
  }

  >>>.el-input--prefix .el-input__inner {
    padding-left: 30px;
  }
</style>
